import { render } from "./ProModeToggle.vue?vue&type=template&id=023a7f09&scoped=true"
import script from "./ProModeToggle.vue?vue&type=script&lang=js"
export * from "./ProModeToggle.vue?vue&type=script&lang=js"

import "./ProModeToggle.vue?vue&type=style&index=0&id=023a7f09&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023a7f09"],['__file',"resources/js/components/ProModeToggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "023a7f09"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('023a7f09', __exports__)) {
    api.reload('023a7f09', __exports__)
  }
  
  module.hot.accept("./ProModeToggle.vue?vue&type=template&id=023a7f09&scoped=true", () => {
    api.rerender('023a7f09', render)
  })

}


export default __exports__